import React from 'react';
import { Link } from 'react-router-dom';
import {sortableHandle} from 'react-sortable-hoc';


const DragHandle = sortableHandle(() => <i className="fas fa-grip-lines drag-cursor" title="drag to sort"></i>);

class WorkoutItem extends React.Component {
  render() {
    let { LinkTo, title, desc, handleDrage } = this.props;
    return (
      <div className="workout-item">
        <i className="fas fa-dumbbell"></i>
        <div className="workout-info">
          <Link to={LinkTo}>{title}</Link>
          <p>{desc}</p>
        </div>
        { handleDrage && <DragHandle /> }
      </div>
    );
  }
}

export default WorkoutItem;
